const Request = require('components/api_request.js');
const Base64 = require('./shared/base64_utf8');
const { alt } = require('@reverbdotcom/discovery-ui');
const { UserStore } = require('@reverbdotcom/discovery-ui');

const moment = require('moment');
require('moment/locale/fr');
require('moment/locale/es');
require('moment/locale/de');
require('moment/locale/ja');

const DISPLAY_CURRENCY_HEADER = 'X-Display-Currency';

function parseMeta(tagName) {
  try {
    const content = document
      .querySelector(`meta[name=${tagName}]`)
      .getAttribute('content');

    return JSON.parse(Base64.decodeToString(content));
  } catch (e) {
    return null;
  }
}

const AppInitializer = {
  init() {
    this.initializeAltStores();
    this.initializeAPIRequest();
    this.initializeLocale();
    this.fixFacebookHash();
  },

  fixFacebookHash() {
    // Facebook adds a strange hash to our url when we log in, which
    // can break tab navigation. This removes it.
    if (window.location.hash === '#_=_') window.location.hash = '';
  },

  initializeAPIRequest() {
    const userConfig = parseMeta('current-user');

    if (userConfig) {
      Request.setDefaultHeader(
        DISPLAY_CURRENCY_HEADER,
        userConfig.user.currency,
      );
    }
  },

  initializeLocale() {
    const userConfig = parseMeta('current-user');
    const translation = parseMeta('js-translations');

    if (userConfig) {
      if (UserStore.isExperimentEnabled('five_digit_locales')) {
        I18n.locale = UserStore.fiveDigitLocale() || I18n.defaultLocale;
      } else {
        I18n.locale = userConfig.user.locale || I18n.defaultLocale;
      }

      moment.locale(I18n.locale);

      if (translation) {
        I18n.translations[I18n.locale.slice(0, 2)] = translation;
      }
    }
  },

  initializeAltStores() {
    const stores = document.getElementById('alt-bootstrap');
    if (stores) {
      alt.bootstrap(stores.textContent);
    }
  },
};

module.exports = AppInitializer;



// WEBPACK FOOTER //
// ./javascripts/components/app_initializer.js